export const OpenSection = [
  "owned",
  "booked-events",
  "my-listed-tee-times",
  "invited-tee-times",
  // "offers-sent" / "offers-received" are kept as recognized values so existing
  // deep links (e.g. the "My Offers" nav shortcut) keep working — they're normalized
  // to the combined "offers" tab, with the sub-tab (Sent/Received) inside it decided
  // by which of these two led here.
  "offers",
  "offers-sent",
  "offers-received",
  "transaction-history",
  "withdrawal",
];
